<template>
  <div>
    <ContentSectionLoader v-show="!loaded" />
    <Transition name="fade">
      <div v-show="loaded">
        <FormList :loaded="loaded" />
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import FormList from './FormList'
import { mapActions } from 'vuex'

export default {
  name: 'Forms',
  components: {
    FormList,
  },
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    this.formGetForms()
      .then(() => {
        this.$emit('loaded')

        this.loaded = true
      })
  },
  methods: {
    ...mapActions([
      'formGetForms',
    ]),
  },
}
</script>
